import { api, unwrap } from './http';

export default {
  getById: async (id) => unwrap(api.get(`/Tenant/${id}`)),

  update: async (id, payload) => unwrap(api.put(`/Tenant/${id}`, payload)),

  getSupportedCountries: async (languageCode = 'en') => unwrap(api.get('/Lookup/supported-countries', { languageCode })),

  getFeatureOptions: async () => unwrap(api.get('/Tenant/FeatureOptions')),

  setFeatureOption: async (code, enabled) => unwrap(api.put('/Tenant/FeatureOptions', { code, enabled })),
};
